import { render, staticRenderFns } from "./individuaidentification.vue?vue&type=template&id=12e1cb68"
import script from "./individuaidentification.vue?vue&type=script&lang=js"
export * from "./individuaidentification.vue?vue&type=script&lang=js"
import style0 from "./individuaidentification.vue?vue&type=style&index=0&id=12e1cb68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports